import React, {Component} from 'react';

interface ClientType {
    client_name: string;
}

interface ClientsType {
    clients: ClientType[];
}

export default class Test extends Component {
    render() {
        return (
            <Clients clients={this.state.clients} />
        )
    }

    state = {
        clients: []
    };

    componentDidMount() {
        if(!this.state.clients.length) {
            fetch('https://2021.apagecode.com/feed.json')
                .then(res => res.json())
                .then((data) => {
                    this.setState({ clients: data.clients })
                })
                .catch(console.log)
        }
    }
}

const Clients = ({clients} : ClientsType) => {
    try{
        return (
            <div>
                <h1>Client List</h1>
                {clients.map((client) => (
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">{client.client_name}</h5>
                        </div>
                    </div>
                ))}
            </div>
        )
    } catch(e){
        return (
            <>{JSON.stringify(clients)}</>
        );
    }

};
